import React from 'react';
import style from './FsBorderLayout.module.css';


class FsBorderLayout extends React.Component {
	constructor(props) {
		super(props);
		// 必须存在this.state中
		this.state = {
			seconds: 0,
			top:'',
			left:'',
			right:'', 
			bottom:'', 
			borderColor:'',
			showOuterBorder:'',
		}

	}
	componentWillMount() {
	 
	}
	clickMethod() {
		console.log("click method");
	}
	
	 


	render() {
		
		let topFrame='';
		let leftFrame="";
		let centerFrame="";
		let rightFrame="";
		let bottomFrame="";
		
		var top = this.props.top;
		var left = this.props.left;
		var right = this.props.right;
		var bottom = this.props.bottom;
		
		var borderColor = "#fff"
		
		
		if(this.props.top)
		{
			topFrame=(<div className={`kee-top-part`}   style={{height:top!=null?top:'0px',borderBottom:borderColor!=null?'1px solid '+borderColor:'none' }} >
							{this.props.topSlot}
						</div>)
		}
		
		if(this.props.left)
		{
			leftFrame = (<div className={`kee-left-part`} style={{width:left!=null?left:'0px',top:top!=null?top:'0',bottom:bottom!=null?bottom:'0',borderRight:borderColor!=null?'1px solid '+borderColor:'none'}}>
				{this.props.leftSlot}
			</div>);
		}
		
		if(this.props.right)
		{
			rightFrame = (<div className={`kee-right-part`}  style={{width:right!=null?right:'0px',top:top!=null?top:'0',bottom:bottom!=null?bottom:'0'}}  >
					{this.props.rightSlot}
				</div>);
		}
		
		if(bottom!=null&&bottom!='0px'&&bottom!='0')
		{
			bottomFrame = (<div className={`kee-bottom-part`}  style={{height:bottom!=null?bottom:'0px',borderTop:borderColor!=null?'1px solid '+borderColor:'none'}} >
							{this.props.bottomSlot}
						</div>);
		}
			  
		return(  
		
		<div    className={`main-container`}>
		
		 
				{topFrame} {leftFrame}
				 
						
				<div  className={`kee-center-part`}  style={{'left':left!=null?left:'0','top':top!=null?top:'0','right':right!=null?right:'0','bottom':bottom!=null?bottom:'0',background: '#EEEEEE'}}>
					{this.props.centerSlot}
				</div> 
				{rightFrame} {bottomFrame}
				
			</div>)
	}
}
export default FsBorderLayout;
